// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"y9C7U","oppositeGenderLinkWrapper":"zkx7x","brandValues":"OhK0r"};